import http from "../http-common";

class LatestBooksService {
  getLatestBooks(numberOfProducts: number) {
    return http.get(`/products/books/latest?noOfProducts=${numberOfProducts.toString()}`);
  }
}

export default new LatestBooksService();
